import React, { useEffect, useState } from "react";
import "./EditModal.css";
import { useDispatch } from "react-redux";
import { updateUserAPI } from "../../../../../../Store/Action/UserAction";
import {
  addUserAddidtionalQuestionsAPI,
  getUserAddidtionalQuestionsAPI,
  getUserDetailsInOnboarding,
} from "../../../../../../Store/Action/onboardingAction";

// Using React.memo to avoid unnecessary re-renders if the props haven't changed
const EditModal = React.memo(
  ({
    isOpen,
    onClose,
    userData,
    setUserOnboardingData,
    fetchOnboardingData,
  }) => {
    const dispatch = useDispatch(); // Redux dispatch for actions
    //   const [whatsAppNumber, setWhatsAppNumber] = useState("");
    //   const [officeEmail, setOfficeEmail] = useState("");
    const [whatsAppNumber, setWhatsAppNumber] = useState("");
    const [officeEmail, setOfficeEmail] = useState("");
    const [userAdditionalQuestionsId, setUserAdditionalQuestionsId] = useState(
      {}
    );
    const [errors, setErrors] = useState({})
    useEffect(() => {
      setWhatsAppNumber(userData?.user_whatsApp_number);
      setOfficeEmail(userData?.user_office_email_id);
    }, [userData]);
    //get all the user additional questions
    useEffect(() => {
      dispatch(
        getUserAddidtionalQuestionsAPI({}, (result) => {
          if (result && Array.isArray(result?.data)) {
            const whatsAppNumber = result?.data?.find(
              (item) => item?.generic_name === "whatsAppNumber"
            );

            const officeEmailInfo = result?.data?.find(
              (item) => item?.generic_name === "workEmailAddress"
            );

            setUserAdditionalQuestionsId((prevState) => ({
              ...prevState, // Retain existing state
              whatsAppNumberId:
                whatsAppNumber?.user_additional_information_id || null, // ID for whatAppNumber
              officeEmailInfoId:
                officeEmailInfo?.user_additional_information_id || null, // ID for workEmailAddress
            }));
          }
        })
      );
    }, [dispatch]);

    if (!isOpen) return null; // Render nothing if modal is not open

    const handleSave = () => {
      if (!validateProfileData()) {
        return;
      }

      let user_additional_information_data = [];
      if (whatsAppNumber) {
        user_additional_information_data.push({
          user_additional_information_id:
            userAdditionalQuestionsId.whatsAppNumberId,
          user_additional_information_data_value: whatsAppNumber,
        });
      }
      if (officeEmail) {
        user_additional_information_data.push({
          user_additional_information_id:
            userAdditionalQuestionsId.officeEmailInfoId,
          user_additional_information_data_value: officeEmail,
        });
      }

      const requestData = {
        user_additional_information_data: user_additional_information_data,
      };

      dispatch(
        addUserAddidtionalQuestionsAPI(requestData, (result) => {
          // After successfully saving, fetch the updated data
          dispatch(
            getUserDetailsInOnboarding({}, (result) => {
              result?.data?.map((item) => {
                if (item.generic_name === "whatsAppNumber") {
                  setUserOnboardingData((prev) => {
                    return {
                      ...prev,
                      user_whatsApp_number:
                        item.user_additional_information_data_value,
                    };
                  });
                }
                if (item.generic_name === "workEmailAddress") {
                  setUserOnboardingData((prev) => {
                    return {
                      ...prev,
                      user_office_email_id:
                        item.user_additional_information_data_value,
                    };
                  });
                }
                if (item.generic_name === "gstNumber") {
                  setUserOnboardingData((prev) => {
                    return {
                      ...prev,
                      user_gst_number:
                        item.user_additional_information_data_value,
                    };
                  });
                }
                if (item.generic_name === "shopName") {
                  setUserOnboardingData((prev) => {
                    return {
                      ...prev,
                      user_shop_name:
                        item.user_additional_information_data_value,
                    };
                  });
                }
              });
            })
          );
        })
      );
      onClose(); // Close the modal after saving
      // window.location.reload();
      // fetchOnboardingData();
    };

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      if (name === "whatsAppNumber") {
        // Remove any non-numeric characters
        const numericValue = value.replace(/\D/g, ""); // Keep only digits
        setWhatsAppNumber(numericValue || null);
      } else if (name === "officeEmail") {
        setOfficeEmail(value || null);
      }

      // // Clear the specific error for the field being edited
      // setErrors((prevErrors) => ({
      //   ...prevErrors,
      //   [name]: "",
      // }));
    };

    const validateProfileData = () => {
      let isValid = true;
      const newErrors = {};

      if (!whatsAppNumber || whatsAppNumber.trim().length !== 10) {
        newErrors.whatsAppNumber = "WhatsApp number must be exactly 10 digits.";
        isValid = false;
      } else if (!/^[6-9]\d{9}$/.test(whatsAppNumber.trim())) {
        newErrors.whatsAppNumber =
          "Enter a valid Indian mobile number (starting with 6-9).";
        isValid = false;
      }

      if (officeEmail && !/^\S+@\S+\.\S+$/.test(officeEmail.trim())) {
        newErrors.officeEmail = "Invalid email format";
        isValid = false;
      }
      setErrors(newErrors);
      return isValid;
    };
    return (
      <div className="modal-overlay-edit1">
        <div className="modal-content-edit1">
          <h4>Edit Profile</h4>
          <div className="inp-fields-div">
            <div className="inp-field">
              <p>WhatsApp Number</p>
              <input
                type="text"
                name="whatsAppNumber"
                value={whatsAppNumber || ""}
                //   onChange={(e) => setWhatsAppNumber(e.target.value)} // Controlled input
                // placeholder={userData?.user_whatsApp_number}
                // onChange={(e) => setWhatsAppNumber(e.target.value)}
                onChange={handleInputChange}
                maxLength={10}
              />
              {errors?.whatsAppNumber && (
                <div style={{color:"red", textAlign:"left", fontSize:"14px", marginTop:"4px"}}>
                <span>{errors?.whatsAppNumber} </span>
                </div>
              )}
            </div>
            <div className="inp-field">
              <p>Office Email ID</p>
              <input
                type="email"
                name="officeEmail"
                // placeholder={userData?.user_office_email_id}
                onChange={(e) => setOfficeEmail(e.target.value)}
                value={officeEmail}
                //   onChange={(e) => setOfficeEmail(e.target.value)} // Controlled input
              />
               {errors?.officeEmail && (
                <div style={{color:"red", textAlign:"left", fontSize:"14px", marginTop:"4px"}}>
                <span>{errors?.officeEmail} </span>
                </div>
              )}
            </div>
          </div>
          <div className="modal-actions">
            <button className="cancel-btn-edit" onClick={onClose}>
              Cancel
            </button>
            <button className="save-btn-edit" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    );
  }
);

export default EditModal;
